import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EnergyBonusesResource, EnergyBonusesResponse, PropertyType } from '@ap/ap-interface-apix-hypotheken-berekening';

@Injectable({
    providedIn: 'root'
})
export class EnergyBonusService {
    private readonly energyBonusesResource = inject(EnergyBonusesResource);

    getEnergyBonuses(propertyType: PropertyType): Observable<EnergyBonusesResponse> {
        return this.energyBonusesResource.getEnergyBonuses(propertyType);
    }
}
